export default function AddSaveHint() {
    return (
        <div>
            <p style={{ fontSize: "14px", color: "#535862", direction: "rtl" }}>* .Bitte reiche alle gespeicherten Änderungen am Ende unter dem Reiter ‘Einreichung’ ein</p>
        </div>
    );
}